import { render, staticRenderFns } from "./AddClientPopup.vue?vue&type=template&id=1fd8acd0&scoped=true"
import script from "./AddClientPopup.vue?vue&type=script&lang=js"
export * from "./AddClientPopup.vue?vue&type=script&lang=js"
import style0 from "./AddClientPopup.vue?vue&type=style&index=0&id=1fd8acd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd8acd0",
  null
  
)

export default component.exports